import React, { useState, useRef, useEffect } from "react";

const InfoTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        onMouseEnter={() => setShowTooltip(true)}
        // onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip((prev) => !prev)}
        aria-describedby={showTooltip ? "" : undefined}
        aria-label="Information about legal entity documents"
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          marginLeft:12,
          borderRadius: "50%",
          backgroundColor: "#EDF5FD",
          border: "1px solid #dfe3e8",
          cursor: "pointer",
        }}
      >
        <span
          style={{
            color: "#95A9BD",
            fontFamily: "graphikmedium",
            fontSize: 26,
          }}
        >
          i
        </span>
      </div>

      {showTooltip && (
        <div
          ref={tooltipRef}
          role="tooltip"
          aria-labelledby="tooltip-content"
          style={{
            position: "absolute",
            top: 40,
            transform: "translateX(-82%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "12px 16px",
            borderRadius: 6,
            width: 300,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: 10,
          }}
        >
          {/* Arrow */}
          {/* Arrow */}
          <div
            style={{
              position: "absolute",
              top: -10,
              left: "92%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "10px solid #ccc",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              top: -9,
              left: "92%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "7px solid transparent",
              borderRight: "7px solid transparent",
              borderBottom: "9px solid #fff",
            }}
          ></div>
          <p id="tooltip-content"
            style={{
              fontFamily: "graphikregular",
              color: "#333333",
              fontSize: 12,
              textAlign: "left"
            }}
          >
            If a legal entity is purchasing the property, please upload the
            formation documents for that entity stamped as filed with the
            relevant state agency (typically the office of the Secretary of
            State where the entity was formed). Examples of acceptable documents
            include stamped copies of: the Articles of Incorporation of a
            corporation, Certificate of Formation for a LLC, Certificate of
            Limited Partnership for a LP.
          </p>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
